<div *ngIf="promptData?.shouldShow">
  <div class="modal-overlay"></div>
  <div class="modal-content">
    <div class="modal-header">
      <h3>Relationship Declaration at Workplace</h3>
    </div>

    <div class="modal-body">
      <p>As part of LTTS' commitment to transparency, fairness, and compliance with the Disclosure of Relationships at
        Workplace Policy, employees are required to disclose relationships covered under the policy.

        This may include relatives, close personal relationships or other relationships that require disclosure.
        Information submitted will be handled confidentially and reviewed in accordance with company policy.</p>
      <p class="pt-2 pb-2"><b>Do you have a relationship that requires disclosure under the Relationship at Workplace Policy?</b></p>
      <p><b>View Policy: </b> <span class="path"> MS TEAMS >> HR POLICY PORTAL >> POLICY ON DISCLOSURE OF RELATIONSHIPS IN
          THE WORKPLACE</span></p>
    </div>

    <div class="modal-actions">
      <button class="btn-no" [disabled]="isProcessing" (click)="onNo()">
        <span *ngIf="isProcessing" class="btn-spinner"></span>
        <span *ngIf="!isProcessing">No, Nothing to Declare</span>
      </button>
      <button class="btn-yes" [disabled]="isProcessing" (click)="onYes()">
        <span *ngIf="isProcessing" class="btn-spinner"></span>
        <span *ngIf="!isProcessing">Yes, Proceed to Declare</span>
      </button>
    </div>
  </div>
</div>